// This function will / should handle emojis 🤣
// because people do some odd things
// for more info check out https://thekevinscott.com/emojis-in-javascript/
export default function getFirstValueFromString(value: string) {
    const firstLetterCodePoint = value.trim().codePointAt(0)

    return String.fromCodePoint(
        firstLetterCodePoint as number,
    ).toLocaleUpperCase()
}
